'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

var _styleHelpers = require('../../styles/styleHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = (0, _extends3.default)({
  '& .menuItems': {
    position: 'absolute',
    minWidth: '125px',
    width: '100%',
    flexDirection: 'column',
    display: 'flex',
    flex: '1',
    zIndex: '10',
    background: 'white',
    cursor: 'pointer',
    padding: '0'
  },
  '& .itemWrapper': {
    display: 'flex',
    flex: '1',
    flexBasis: '100%',
    flexWrap: 'wrap',
    padding: '0',
    ':hover': {
      backgroundColor: '#73a4f4'
    }
  },
  '& .action': {
    width: '100%',
    padding: '1.5em 1em',
    color: 'black'
  },
  '& .trigger': {
    cursor: 'pointer',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  '.menu': {
    height: '100%',
    width: '100%',
    display: 'inline-block',
    position: 'relative'
  },
  '& .handleOutsideClick': {
    position: 'fixed',
    cursor: 'default',
    opacity: '0',
    width: '100vw',
    height: '100vh',
    top: 0,
    left: 0
  }
}, (0, _styleHelpers.makeAnimation)({
  name: 'fade-in',
  from: { opacity: '0' },
  to: { opacity: '1' },
  on: 'opacity',
  duration: '150'
}));

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref) {
  var isExpanded = _ref.isExpanded;
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _extends3.default)({
    '& .menuItems': {
      boxShadow: isExpanded ? '1px 1px 1px 1px rgba(0,0,0,0.27)' : ''
    }
  }, (0, _objectResolvePath2.default)(theme, 'Dropdown.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Dropdown/Dropdown.style.js
// module id = 366
// module chunks = 0